import React, { useState } from "react";


import { useLoading } from '../../../../context/LoadingContext';
import CompareOffer from "./CompareOffer";

import BrowseProducts from "./BrowseProducts";
import GPOffers from "../../offers/offer"
import MarketInsight from "../../../../components/common/MarketInsights";
import BankInsight from "../../../../components/common/BankInsights";
import AgriTradeCreditAssess from "../../../../components/common/AgriTradeCreditAssess";


const GPDiscoverEvaluate = () => {
   
    const [activeTab, setActiveTab] = useState("Browse Products"); // Set default back to Browse Products
    const tabs = ["Browse Products", "Compare Offers",,"Market Insights","Bank Insights", "Agri Trade Credit Assess"]; 
    const renderTabContent = () => {
        console.log('activeTab@@',activeTab);
        switch (activeTab) {
            case "Browse Products":
                return <BrowseProducts />;
            
            // case "All Offers":
            //     return <GPOffers/>;
            case "Compare Offers":
                return <CompareOffer />;
            case "Market Insights":
                return <MarketInsight />;
            case "Bank Insights":
                return <BankInsight />;
            case "Agri Trade Credit Assess":
                return <AgriTradeCreditAssess />;
            default:
                <BrowseProducts />;
        }
    };

    return (
        <div className="buyer-layout">
           
            <div className="amtpl-tabs">
               
                <div className="content3">
                    <main className="main-content">
                        <div className=" main-tab">
                            {tabs.map((tab) => (
                                <button
                                    key={tab}
                                    className={`buttonclass ${
                                        activeTab === tab
                                            ? "active"
                                            : "notactive"
                                    }`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                        <div className="row">{renderTabContent()}</div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default GPDiscoverEvaluate;